// Vendors
import $ from 'jquery';
import { AJAX_URL } from '../config';

jQuery(document).ready(function ($) {
  let currentQuestion = 0;
  const totalQuestions = $('.question-card').length;

  // function to handle showing/hiding questions
  function showQuestion(questionIndex) {
    $('.question-card').each(function (index) {
      if (index === questionIndex) {
        $(this).removeClass('hidden');
        $(this).addClass('current-question');
      } else {
        $(this).addClass('hidden');
        $(this).removeClass('current-question');
      }
    });

    //scroll to top of page
    $('html, body').animate(
      {
        scrollTop: $('section.quiz-single').offset().top
      },
      'slow'
    );
  }

  // function to check answer
  function checkAnswer($liClicked) {
    let $questionMain = $liClicked.closest('.question-main');
    let questionId = $questionMain.data('question-id');
    let answerValue = $liClicked.data('answer-value');
    let $currentQuestionCard = $liClicked.closest('.question-card');

    // Show the loading spinner
    $('.loading-spinner').removeClass('hide');

    // ajax call to check if answer is correct or not, uses lib/ajax/ajax-check-answer
    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}check_answer`,
      data: {
        question_id: questionId,
        answer_value: answerValue
      },
      success: function (response) {
        // Hide the loading spinner
        $('.loading-spinner').addClass('hide');

        // display modal button if it exists
        let $modalButton = $liClicked
          .closest('.answers')
          .siblings('.question-submit')
          .find('.learn-more-btn');
        if ($modalButton.length && $modalButton.hasClass('hidden')) {
          $modalButton.removeClass('hidden');
        }

        // hide the skip button and show the next question button
        $currentQuestionCard.find('.next-btn').removeClass('hidden');
        $currentQuestionCard.find('.skip-btn').addClass('hidden');

        // handle the response
        if (response.correct) {
          $currentQuestionCard
            .removeClass('answer-wrong')
            .addClass('answer-right');
          // update the #see_results button with the number of answers correct
          let currentCorrectAnswers = parseInt(
            $('#see_results').attr('data-correct-answers')
          );
          $('button.end-quiz').attr(
            'data-correct-answers',
            currentCorrectAnswers + 1
          );
          $('#see_results').attr(
            'data-correct-answers',
            currentCorrectAnswers + 1
          );
          // add confetti effect
          confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.8 }
          });
        } else {
          $currentQuestionCard
            .removeClass('answer-right')
            .addClass('answer-wrong');
        }
      },
      error: function () {
        console.error('There was an error checking the answer.');
      }
    });
  }

  // function to set cookie for quiz score
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '0') + expires + '; path=/';
  }

  // function to clear cookie for quiz score
  function deleteCookie(name) {
    document.cookie =
      name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
  }

  // Event listener to add class 'selected' to answer when clicked, check if the answer is correct
  $('.answers li').on('click', function () {
    $(this).siblings().removeClass('selected').addClass('not-selected');
    $(this).addClass('selected').removeClass('not-selected');
    let $currentQuestionCard = $(this).closest('.question-card');
    $currentQuestionCard
      .removeClass('answer-wrong')
      .removeClass('answer-right');

    checkAnswer($(this)); // call the function to check the answer immediately

    // Unbind the click event for all answers of this question
    $(this).siblings().off('click');
    $(this).off('click');
  });

  // Event listener for 'Skip' button
  $('.skip-btn, .next-btn').on('click', function () {
    if (currentQuestion < totalQuestions - 1) {
      currentQuestion++;
      showQuestion(currentQuestion);
    }
  });

  // Event listener for 'See Results' and "End Quiz" buttons
  $('#see_results, button.end-quiz').on('click', function () {
    const $this = $(this);
    const correctAnswers = parseInt($this.attr('data-correct-answers'));
    const totalQuestions = parseInt($this.data('total-questions'));
    const quizId = $this.data('quiz-id');
    const percentageCorrect = Math.round(
      (correctAnswers / totalQuestions) * 100
    );

    // Hide the current question card
    $this.closest('.question-card').addClass('hidden');

    // save quiz result as cookie
    const cookieName = 'quiz_score_' + quizId;
    setCookie(cookieName, percentageCorrect, 30);

    // update the results text based on score
    const resultsTextElement = $('#results_text');
    let message;
    if (percentageCorrect < 50) {
      message = 'Better luck next time.';
    } else if (percentageCorrect >= 50 && percentageCorrect < 80) {
      message = 'Pretty good, but you can do better.';
    } else {
      message = "Great Job. You're a Texas Counties Master.";
      // add confetti firework effect
      let duration = 15 * 1000;
      let animationEnd = Date.now() + duration;
      let defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0
      };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      let interval = setInterval(function () {
        let timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        let particleCount = 50 * (timeLeft / duration);
        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
          })
        );
        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
          })
        );
      }, 250);
    }
    resultsTextElement.text(message);

    // Update the content of #progress_value with the calculated percentage
    $('#progress_value').text(percentageCorrect + '%');

    // Update the circle's progress
    const circumference = 360;
    const offset = circumference - (percentageCorrect / 100) * circumference;

    // Animate the circle's stroke-dashoffset using jQuery
    $('.meter-1').animate(
      {
        'stroke-dashoffset': offset
      },
      1000
    );

    // Create and update the share message
    const shareMessage = `I scored ${percentageCorrect}% on a Texas Counties Quiz! Check it out!`;
    $('li.twitter a').attr('data-share-text', shareMessage);
    $('li.linkedin a').attr('data-share-text', shareMessage);

    // show quiz results
    $('#quiz_results').removeClass('hidden');

    //scroll to top of page
    $('html, body').animate(
      {
        scrollTop: $('section.quiz-single').offset().top
      },
      'slow'
    );
  });

  // Event listener for 'Play Again' button
  $('#play_again').on('click', function () {
    $('#quiz_results').addClass('hidden');
    currentQuestion = 0;
    showQuestion(currentQuestion);
    $('#see_results').attr('data-correct-answers', 0);
    $('.answers li').removeClass('selected').removeClass('not-selected');
    $('.next-btn').addClass('hidden');
    $('.skip-btn').removeClass('hidden');
    $('.next-btn').addClass('hidden');
    $('.skip-btn').removeClass('hidden');
    $('.learn-more-btn').addClass('hidden');
    $('.check-answer').removeClass('hidden');

    // Re-bind the click event for .answers li
    $('.answers li').on('click', function () {
      $(this).siblings().removeClass('selected').addClass('not-selected');
      $(this).addClass('selected').removeClass('not-selected');
      let $currentQuestionCard = $(this).closest('.question-card');
      $currentQuestionCard
        .removeClass('answer-wrong')
        .removeClass('answer-right');

      checkAnswer($(this)); // call the function to check the answer immediately

      // Unbind the click event for all answers of this question
      $(this).siblings().off('click');
      $(this).off('click');
    });
  });

  // Event listener for 'Clear Score' button
  $('.clear-score').on('click', function () {
    const quizId = $(this).data('clear-score');

    // delete quiz score cookie
    const cookieName = 'quiz_score_' + quizId;
    deleteCookie(cookieName);

    // Determine the current URL
    const currentUrl = window.location.href;

    // If on the main quiz page, reload the page
    if (currentUrl.includes('/quizzes/')) {
      location.reload();

      // If single quiz page, return to main quiz page
    } else {
      window.location.href = '/quizzes/';
    }
  });

  // Show the first question initially
  showQuestion(currentQuestion);
});
